import { IRCContact } from '@numeo/types-core'
import { FormControl, FormLabel, Input, Stack } from '@mui/joy'
import React from 'react'

interface ContactFieldGroupProps {
    contact: IRCContact
    onChange: (contact: IRCContact) => void
    disabled?: boolean
}

export const ContactFieldGroup: React.FC<ContactFieldGroupProps> = ({ contact, onChange, disabled = false }) => {
    const handleChange = (field: keyof IRCContact, value: string | null) => {
        onChange({
            ...contact,
            [field]: value || null,
        })
    }

    return (
        <FormControl>
            <FormLabel>Contact Information</FormLabel>
            <Stack spacing={1.5}>
                <Input
                    placeholder="Contact Name"
                    value={contact.name || ''}
                    onChange={(e) => handleChange('name', e.target.value)}
                    disabled={disabled}
                    size="sm"
                />
                <Input
                    placeholder="Phone Number"
                    value={contact.phone || ''}
                    onChange={(e) => handleChange('phone', e.target.value)}
                    disabled={disabled}
                    size="sm"
                    type="tel"
                />
                <Input
                    placeholder="Email Address"
                    value={contact.email || ''}
                    onChange={(e) => handleChange('email', e.target.value)}
                    disabled={disabled}
                    size="sm"
                    type="email"
                />
            </Stack>
        </FormControl>
    )
}
